// Constant: Generic > Intent icon mapping
const INTENT_ICON_MAPPING = Object.freeze({ danger: 'error', primary: 'info-sign', success: 'tick', warning: 'warning-sign' })

// Constant: Generic > Right-to-left languages
const RTL_LANGUAGES = Object.freeze(['ar', 'he', 'fa', 'ps', 'ur', 'yi'])

// Export
export {
	INTENT_ICON_MAPPING,
	RTL_LANGUAGES
}
